<template>
  <div class="Beefalo">
    <ol>
      <li>
        <div>주사위를 굴려 가장 높은 수가 나오는 순서대로 비팔로를 선택합니다</div>
        <div>비팔로 무리 중 1마리는 일반 비팔로 이며 5마리만 이동속도가 높은 라이더 비팔로 입니다</div>
      </li>
      <li>
        <div>경기를 시작 하기 전, 캠프에 있는 개인 미션을 제일 낮은 번호부터 순서대로 선택합니다</div>
        <div>포장지를 풀었을 때 나오는 아이템이 자신의 미션입니다</div>
      </li>
      <li>자신의 미션을 확인한 후, 경주 출발지점에서 동시에 시작하며, 가장 먼저 상자에 넣어 놓고 "완료"라고 외치는 사람이 승리입니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Beefalo'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Beefalo.vue